module.exports = __webpack_public_path__ + "static/media/Builders Hardware Manufacturers Association Logo.06f83f5e.png";